import {Theme as FundamentalTheme, useFundamentalContext} from '@hm/fundamental'
import {useEffect} from 'react'

const HCONNECT_THEME_LIGHT: FundamentalTheme = 'ThemeLightBlue'

export const FundamentalThemeInitializer = () => {
  const {theme: fundamental} = useFundamentalContext()

  useEffect(() => {
    if (fundamental.currentTheme !== HCONNECT_THEME_LIGHT) {
      fundamental.updateTheme(HCONNECT_THEME_LIGHT)
    }
  }, [fundamental])

  return null
}
